import { AppRoutesNavigation } from 'src/app-routes'
import { IUserWithPortalAccess } from 'src/generated-types'

/** Default redirect when a feature gate blocks access. */
export function getAppFeatureBlockedRedirect(
  user: IUserWithPortalAccess | undefined,
  customerId?: number,
  redirectTo?: string,
): string {
  if (redirectTo) {
    return redirectTo
  }

  if (customerId != null) {
    return AppRoutesNavigation.Customer.localities(customerId)
  }

  if (user?.hasLocalityAccess) {
    return AppRoutesNavigation.Localities.main
  }
  if (user?.hasServiceStationAccess) {
    return AppRoutesNavigation.serviceStation.main
  }
  return AppRoutesNavigation.UnAuth
}
